import * as React from 'react';
import Box from '../Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

type TTextFieldCharacterCountLabel = {
  characterCount: number;
  maxLength: number;
  charsRemainingText?: string;
  charsExceededText?: string;
};

const VALUE_PLACEHOLDER = /:value/g;

const TextFieldCharacterCountLabel = ({
  characterCount = 0,
  maxLength = 0,
  charsRemainingText = ':value characters remaining',
  charsExceededText = ':value characters too many',
}: TTextFieldCharacterCountLabel) => {
  const conditionalProps = filterConditionalKeyValues({
    states: characterCount > maxLength && 'errored',
  });
  const charsRemaining = maxLength - characterCount;
  const charsExceeded = characterCount - maxLength;
  const labelKey = charsRemaining >= 0 ? charsRemainingText : charsExceededText;
  const labelValue = charsRemaining >= 0 ? charsRemaining : charsExceeded;

  const label = labelKey.replace(VALUE_PLACEHOLDER, labelValue.toString());
  return (
    <>
      <Box {...conditionalProps} as="span" parent="TextField" name="characterCountAmount">
        {label}
      </Box>
    </>
  );
};

export default TextFieldCharacterCountLabel;
